import { Option } from "../components/SelectBox/SelectBox";

const MONTH_OPTIONS: Option[] = [
  {
    label: "Ocak",
    value: "1",
  },
  {
    label: "Şubat",
    value: "2",
  },
  {
    label: "Mart",
    value: "3",
  },
  {
    label: "Nisan",
    value: "4",
  },
  {
    label: "Mayıs",
    value: "5",
  },
  {
    label: "Haziran",
    value: "6",
  },
  {
    label: "Temmuz",
    value: "7",
  },
  {
    label: "Ağustos",
    value: "8",
  },
  {
    label: "Eylül",
    value: "9",
  },
  {
    label: "Ekim",
    value: "10",
  },
  {
    label: "Kasım",
    value: "11",
  },
  {
    label: "Aralık",
    value: "12",
  },
];

export interface IYearMonthModel {
  year: number;
  months: Option[];
}

export const groupByYear = (
  list: { year: number; month: number }[]
): IYearMonthModel[] => {
  let result: IYearMonthModel[] = [];

  for (let i = 0; i < list.length; i++) {
    const { year, month } = list[i];

    let yearGroup: IYearMonthModel | undefined = result.find(
      (item) => item.year === year
    );

    if (yearGroup) {
      yearGroup.months.push(MONTH_OPTIONS[month - 1]);
    } else {
      result.push({ year: year, months: [MONTH_OPTIONS[month - 1]] });
    }
  }

  return result;
};
